import React from 'react';
import { getLcn } from '~/utils/labeled-classnames';
import { useFetchNewChart } from '../../api/charts_queries';
import SpinnerTw from '~/components/SpinnerTw';
import InfoBox from '~/shared/components/info_boxes/InfoBox';
import ChartEdit from '../charts/edit/ChartEdit';

export default function ChartNew() {
  const fetchNewChartQuery = useFetchNewChart()

  const { data: chart } = fetchNewChartQuery

  if (fetchNewChartQuery.isLoading) {
    return <SpinnerTw size='lg' />;
  }

  if (fetchNewChartQuery.isError) {
    return <InfoBox type='error'>
      There was an error loading the chart.
    </InfoBox>;
  }

  if (!chart) {
    return <InfoBox type='error'>
      Chart creation not available.
    </InfoBox>;
  }

  const lcn = getLcn({
    chartNew: ''
  });

  return (
    <div className={lcn.chartNew}>
      <ChartEdit chart={chart} />
    </div>
  );
}; 